<template>
  <v-layout row wrap fill-height align-center justify-center class="secondary lighten-1">
    <v-flex xs12 sm4 align-center justify-center>
      <v-card class="vop-bg-whisper secondary--text">
        <v-card-title primary-title>
          <div class="headline error--text">Access Denied</div>
        </v-card-title>
        <v-card-text>
          <span class="grey--text body-2 text--darken-2">You do not have access to the requested view, pelase contact
            your administrator</span> <br />
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="navigateTo('Home')">Home</v-btn>
          <v-btn color="primary" v-if="IS_SIGNED_INTO_MPX" flat @click="navigateTo('MPXAccountSelection')">Switch
            Account</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"

import AppService from "@/AppService"
import { IS_SIGNED_INTO_CABLE, IS_SIGNED_INTO_MPX } from "@/store/constants/getter-types"

export default {
  name: "AccessDenied",
  data() {
    return {
      queryItems: AppService.getQueryItems(),
      configurationItems: AppService.getConfigurationItems()
    }
  },
  computed: {
    ...mapGetters([
      IS_SIGNED_INTO_CABLE,
      IS_SIGNED_INTO_MPX
    ])
  },
  methods: {
    /**
     *  navigateTo
     * @param {string} pathName
     */
    navigateTo(pathName) {
      this.$router.push({
        name: pathName
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/Home/AccessDenied.vue